import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const exportScaleToPDF = async (element, filename = 'scale', options = {}) => {
  try {
    const {
      scale = 2,           
      useCORS = true,      
      logging = false,     
      backgroundColor = '#ffffff'
    } = options;

    const canvas = await html2canvas(element, {
      scale,
      useCORS,
      logging,
      backgroundColor
    });

    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'in',
      format: 'letter'
    });

    const pdfWidth = 11;
    const pdfHeight = 8.5;
    const imgData = canvas.toDataURL('image/png', 1.0);
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${filename}.pdf`);
  } catch (error) {
    console.error('Error exporting scale to PDF:', error);
    throw error;
  }
};

export const generateScaleFilename = (viewerKey) => {
  const root = viewerKey.root.replace('#', 'sharp');
  const type = viewerKey.type.toLowerCase().replace(/\s+/g, '-');
  const date = new Date().toISOString().split('T')[0];

  return `${root}-${type}-scale-${date}`;
};
